module.exports = __webpack_public_path__ + "img/sensibilizacion-2.b2c85bf2.png";